import React from "react";

const CandidateIcon = ({ cls = "" }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M13 12.5C13.9889 12.5 14.9556 12.2068 15.7779 11.6574C16.6001 11.1079 17.241 10.3271 17.6194 9.41342C17.9978 8.49979 18.0969 7.49446 17.9039 6.52455C17.711 5.55465 17.2348 4.66373 16.5355 3.96447C15.8363 3.26521 14.9454 2.789 13.9755 2.59608C13.0055 2.40315 12.0002 2.50217 11.0866 2.8806C10.173 3.25904 9.39206 3.89991 8.84265 4.72215C8.29324 5.5444 8 6.5111 8 7.5C8.00132 8.82568 8.52853 10.0967 9.46593 11.0341C10.4033 11.9715 11.6743 12.4987 13 12.5ZM13 4.16667C13.6593 4.16667 14.3037 4.36217 14.8519 4.72844C15.4001 5.09471 15.8273 5.6153 16.0796 6.22439C16.3319 6.83348 16.3979 7.5037 16.2693 8.1503C16.1407 8.79691 15.8232 9.39085 15.357 9.85703C14.8908 10.3232 14.2969 10.6407 13.6503 10.7693C13.0037 10.8979 12.3335 10.8319 11.7244 10.5796C11.1153 10.3273 10.5947 9.90007 10.2284 9.3519C9.86216 8.80374 9.66667 8.15927 9.66667 7.5C9.66667 6.61595 10.0179 5.7681 10.643 5.14298C11.2681 4.51786 12.1159 4.16667 13 4.16667Z"
        fill="currentColor"
      />
      <path
        d="M12.5 14.5C10.5116 14.5021 8.60518 15.2614 7.19914 16.6112C5.79309 17.961 5.00221 19.7911 5 21.7C5 21.9122 5.0878 22.1157 5.24408 22.2657C5.40036 22.4157 5.61232 22.5 5.83333 22.5C6.05435 22.5 6.26631 22.4157 6.42259 22.2657C6.57887 22.1157 6.66667 21.9122 6.66667 21.7C6.66667 20.2148 7.28125 18.7904 8.37521 17.7402C9.46917 16.69 10.9529 16.1 12.5 16.1C14.0471 16.1 15.5308 16.69 16.6248 17.7402C17.7188 18.7904 18.3333 20.2148 18.3333 21.7C18.3333 21.9122 18.4211 22.1157 18.5774 22.2657C18.7337 22.4157 18.9457 22.5 19.1667 22.5C19.3877 22.5 19.5996 22.4157 19.7559 22.2657C19.9122 22.1157 20 21.9122 20 21.7C19.9978 19.7911 19.2069 17.961 17.8009 16.6112C16.3948 15.2614 14.4884 14.5021 12.5 14.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CandidateIcon;
